// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderStats_wrapper__-Gl2T","tabs":"OrderStats_tabs__goFyp","tab":"OrderStats_tab__YXA0V","active":"OrderStats_active__BZDJX","list":"OrderStats_list__TkTeX"};